import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgImage = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23.625 4.375H4.375a1.75 1.75 0 0 0-1.75 1.75v15.75a1.75 1.75 0 0 0 1.75 1.75h19.25a1.75 1.75 0 0 0 1.75-1.75V6.125a1.75 1.75 0 0 0-1.75-1.75Zm0 1.75v11.238l-2.851-2.85a1.75 1.75 0 0 0-2.476 0l-2.187 2.188-4.813-4.813a1.75 1.75 0 0 0-2.474 0l-4.449 4.45V6.124h19.25ZM4.375 18.813l5.688-5.688 8.75 8.75H4.374v-3.063Zm19.25 3.062h-2.337l-3.938-3.938 2.188-2.187 4.087 4.088v2.037ZM15.75 10.937a1.313 1.313 0 1 1 2.626 0 1.313 1.313 0 0 1-2.626 0Z" />
  </svg>
);
export default SvgImage;
